<template>
  <div class="admin-banner">
    <img :src="adminBanner" alt="" />
    <div class="absolute">
      <div class="title">数字家园管理系统</div>
      <div class="text">
        数字家园管理，以数“治”家，创新科技应用，软件硬件一体化，赋能物业，打通线上线下，助力物业智能化，构建社区生活新生态，实现智慧家园。
      </div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../../components/pc/components/Experience.vue";

import adminBanner from "../../../../assets/product/adminBanner.png";

export default {
  setup() {
    return reactive({
      adminBanner: adminBanner,
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.admin-banner {
  position: relative;
}
.admin-banner img {
  width: 100%;
  height: 628px;
}
@media screen and (max-width: 1180px) {
  .admin-banner {
    min-width: 1180px;
  }
}
.absolute {
  position: absolute;
  top: 30%;
  left: 33%;
  transform: translate(-50%, -50%);
}
.absolute .title {
  font-size: 30px;
  color: #fff;
}
.absolute .text {
  width: 490px;
  font-size: 14px;
  margin-top: 30px;
  color: #fff;
}
.absolute .experience {
  margin-top: 60px;
  font-size: 16px;
  color: #fff;
  width: 108px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #fff;
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  cursor: pointer;
}
</style>
